import axios from "axios";

const API_URL = "https://backend.gouniquejourneys.co.uk/api/employee/dashboard"; // Update with actual backend URL

export const fetchDashboardStats = async () => {
  try {
    const response = await axios.get(`${API_URL}/dashboard-statistic`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard stats:", error);
    throw error;
  }
};
